<template>
  <v-row no-gutters>
    <!-- title -->
    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col cols="6" class="d-flex flex-column">
          <span class="body-regular-small title-text-color">{{
            $t(i18nPath + 'playlistName.title')
          }}</span>
          <span class="body-regular-smaller desc-text-color">{{
            $t(i18nPath + 'playlistName.desc')
          }}</span>
        </v-col>
        <v-col cols="6">
          <v-input v-model="playlistData.name" hide-details></v-input>
        </v-col>
      </v-row>
    </v-col>
    <!-- desc -->
    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col cols="6" class="d-flex flex-column">
          <span class="body-regular-small title-text-color">{{
            $t(i18nPath + 'playlistDesc.title')
          }}</span>
          <span class="body-regular-smaller desc-text-color">{{
            $t(i18nPath + 'playlistDesc.desc')
          }}</span>
        </v-col>
        <v-col cols="6">
          <v-textarea
            v-model="playlistData.description"
            hide-details
            auto-grow
            density="compact"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-col>
    <!-- access -->
    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col cols="6" class="d-flex flex-column">
          <span class="body-regular-small title-text-color">{{
            $t(i18nPath + 'playlistAccess.title')
          }}</span>
          <span class="body-regular-smaller desc-text-color">{{
            $t(i18nPath + 'playlistAccess.desc')
          }}</span>
        </v-col>
        <v-col cols="6" style="position: relative">
          <v-select
            v-model="playlistData.access_type"
            :items="accessTypeItems"
            style="position: relative"
            :menu-props="{
              'content-class': 'access-select-menu',
              maxWitdh: 280,
              offsetY: true,
              closeOnContentClick: true,
            }"
            append-icon="mdi-chevron-down"
            class="access-select"
            :persistent-placeholder="true"
            outlined
            hide-details
          >
            <template #item="{ item }">
              <v-list-item
                class="d-flex access-options-list"
                @click="playlistData.access_type = item.value"
              >
                <v-icon
                  size="16"
                  class="neutral-30-base--text mr-2 align-self-start"
                  v-if="item.value === playlistData.access_type"
                  >mdi-check</v-icon
                >
                <div class="d-flex flex-column">
                  <v-list-item-title>
                    <span
                      class="access-option-title-text-color body-regular-smaller"
                    >
                      {{ item.name }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span
                      class="access-option-subtitle-text-color body-regular-smaller"
                    >
                      {{ item.subtitle }}
                    </span>
                  </v-list-item-subtitle>
                </div>
              </v-list-item>
            </template>
            <template #selection="{ item }">
              <div class="v-select__selection">
                {{ item ? `${item.name}` : '' }}
              </div>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-col>

    <v-col
      cols="12"
      class="mb-6"
      v-if="playlistData.access_type === 'anyone_with_password'"
    >
      <v-row no-gutters align="center" class="pa-2">
        <v-col cols="6" class="d-flex flex-column">
          <span class="body-regular-small title-text-color">{{
            $t('message.playlist.settings.tabs.general.playlistPassword.title')
          }}</span>
          <span class="body-regular-smaller desc-text-color">{{
            $t('message.playlist.settings.tabs.general.playlistPassword.desc')
          }}</span>
        </v-col>
        <v-col cols="6" style="position: relative">
          <v-input
            v-model="password"
            :type="showPass ? 'text' : 'password'"
            :placeholder="$t('message.playlist.share.password.placeholder')"
            class="access-select"
            counter="40"
            max="40"
          >
            <template #append>
              <v-icon size="16" @click="showPass = !showPass">
                {{
                  !showPass ? 'panda-eye-appearing' : 'panda-eye-hidden'
                }}</v-icon
              >
            </template>
          </v-input>
        </v-col>
      </v-row>
    </v-col>
    <div class="save-action-divider"></div>
    <v-col cols="12" class="my-6">
      <div class="d-flex justify-end px-6">
        <base-btn type="tertiary" @click="handleGoBack">
          {{ $t('message.actions.cancel') }}
        </base-btn>
        <base-btn
          :disabled="!hasChanges || loadings.saveChanges"
          :loading="loadings.saveChanges"
          @click="handleSaveChanges"
          class="ml-2"
        >
          {{ $t('message.actions.save') }}
        </base-btn>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import i18n from '@/translations/lang'
import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import playlistApi from '@/services/playlistApi'

export default {
  name: 'GeneralTab',
  data: () => ({
    i18nPath: 'message.playlist.settings.tabs.general.',
    playlistData: {
      name: '',
      description: '',
      access_type: 'anyone_with_password',
    },
    initialPlaylistData: {},
    password: '',
    loadings: {
      saveChanges: false,
    },
    showPass: false,
  }),
  mounted() {
    this.$root.$on('updatePlaylistAccessType', (type) => {
      this.playlistData.access_type = type
      this.initialPlaylistData.access_type = type
    })
    this.handleResetData()
  },
  beforeDestroy() {
    this.$root.$off('updatePlaylistAccessType')
  },
  watch: {
    playlist: {
      handler(val) {
        console.log('👀 ~ handler ~ val:', val)
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      playlist: (state) => state.playlist.playlist,
    }),
    hasChanges() {
      return (
        !_.isEqual(this.playlistData, this.initialPlaylistData) || this.password
      )
    },
    accessTypeItems() {
      return [
        {
          name: i18n.t(
            this.i18nPath + 'playlistAccess.selectOptions.anyoneWithPassword'
          ),
          subtitle: i18n.t(
            this.i18nPath +
              'playlistAccess.selectOptions.anyoneWithPasswordDesc'
          ),
          value: 'anyone_with_password',
        },
        {
          name: i18n.t(
            this.i18nPath + 'playlistAccess.selectOptions.anyoneWithLink'
          ),
          subtitle: i18n.t(
            this.i18nPath + 'playlistAccess.selectOptions.anyoneWithLinkDesc'
          ),
          value: 'anyone_with_link',
        },
      ]
    },
  },
  methods: {
    ...mapMutations('playlist', ['UPDATE_PLAYLIST']),
    async handleResetData() {
      this.playlistData.name = this.playlist.name
      this.playlistData.description = this.playlist.description
      this.playlistData.access_type = this.playlist.access_type

      this.initialPlaylistData = _.cloneDeep(this.playlistData)
    },
    async handleSaveChanges() {
      this.loadings.saveChanges = true
      if (this.password) {
        this.playlistData.password = this.password
      }
      try {
        const { data } = await playlistApi.updatePlaylist(
          this.playlistData,
          this.playlist.id
        )
        if (data) {
          this.UPDATE_PLAYLIST(data)
        }
        this.handleResetData()
        this.password = ''
        this.showSuccessSnackbarAlert()
      } catch (error) {
        console.error('Error saving changes: ', error)
        this.showErrorSnackbarAlert(
          error?.response?.data?.errMsg ?? error?.response?.status
        )
      }
      this.loadings.saveChanges = false
    },
    handleGoBack() {
      this.$router.push({ name: 'Playlists' })
    },
    showSuccessSnackbarAlert() {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: this.$t('message.pages.video.changesSaved'),
        type: 'success',
      })
    },
    showErrorSnackbarAlert(errMsg = '') {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: `${this.$t('message.error')}: ${errMsg}`,
        type: 'error',
      })
    },
  },
}
</script>

<style lang="scss">
html .v-input.access-select {
  .v-input__append-inner .v-icon {
    margin-top: 2px !important;
  }
  &.filled {
    .v-input__append-inner .v-icon {
      color: varFigma(neutral-60) !important;
    }

    &:hover {
      .v-input__append-inner .v-icon {
        color: varFigma(brand-60-base) !important;
      }
    }
  }
  &.v-input--is-focused {
    &.v-input--is-dirty {
      .v-input__append-inner .v-icon {
        color: varFigma(brand-60-base) !important;
      }
    }
    .v-input__append-inner .v-icon {
      color: varFigma(brand-60-base) !important;
    }
  }
}
html .base-select.v-input.access-select {
  &.filled {
    .v-input__icon--append i {
      color: varFigma(neutral-60) !important;
    }

    &:hover {
      .v-input__icon--append i {
        color: varFigma(brand-60-base) !important;
      }
    }
  }
  &.v-input--is-focused {
    &.v-input--is-dirty {
      .v-input__icon--append i {
        color: varFigma(brand-60-base) !important;
      }
    }
    .v-input__icon--append i {
      color: varFigma(brand-60-base) !important;
    }
  }
}
.access-select-menu {
  max-width: 280px;

  .access-options-list {
    padding: 12px 16px !important;
    min-height: unset;

    .v-list-item__title {
      align-self: auto;
    }
    .v-list-item__subtitle {
      white-space: normal;
    }
    .v-list-item--active {
      background-color: varFigma(brand-95-lighter) !important;
      color: varFigma(brand-40-dark) !important;
    }
  }
  .v-select-list {
    padding: 0 !important;
  }
}

.title-text-color {
  color: varFigma(neutral-20-dark);
}
.desc-text-color {
  color: varFigma(neutral-40-light);
}
.access-option-title-text-color {
  color: varFigma(neutral-30-base);
}
.access-option-subtitle-text-color {
  color: varFigma(neutral-50);
}
</style>

<style lang="scss" scoped></style>
